<template>
  <model-form
    ref="modelForm"
    :model="reportElement"
    :modal-type="(reportElement.isLocal || editing) ? 'modal' : 'maximized-modal'"
    :width="editing ? '800px' : '500px'"
    :handled-actions="handledActions"
    @model-created="$emit('model-created')"
  >
    <div class="column">
      <div class="row q-gutter-md q-mb-md">
        <q-input
          v-model="reportElement.name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          :autofocus="!$q.platform.is.ios"
        />
        <q-select
          v-model="reportElement.componentName"
          class="col-6"
          :options="filteredReportComponents"
          map-options
          emit-value
          option-value="name"
          stack-label
          label="Component"
          use-input
          clearable
          @filter="filterReportComponents"
          @update:model-value="reportElement.name = reportElement.componentName"
        >
          <template #option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
            >
              <q-item-section avatar>
                <q-icon :name="scope.opt.icon" />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  <span v-if="scope.opt.deprecated"><s>{{ scope.opt.name }}</s>
                    <q-icon
                      class="q-ml-xs"
                      name="error"
                      size="sm"
                    >
                      <q-tooltip>
                        This report element will be removed in the future and should no longer be used.
                      </q-tooltip>
                    </q-icon></span>
                  <span v-else>{{ scope.opt.name }}</span>
                </q-item-label>
              </q-item-section>
            </q-item>
          </template>
          <template #selected-item="scope">
            <q-item
              class="q-pa-none q-ma-none"
              dense
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
            >
              <q-item-section avatar>
                <q-icon :name="scope.opt.icon" />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ scope.opt.name }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </div>
    <div
      v-if="reportElement.isRemote"
      class="column"
    >
      <report-controls
        :report-element="reportElement"
        :options-variables="['default', 'override', 'final']"
      />
    </div>
  </model-form>
</template>

<script>
import Report, { isOptionSet, optionNamesForControlName, setDefaultOption, unsetOption } from 'src/models/report/Report'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ReportControls from 'src/modules/admin/report/ReportControls'

export default {
  name: 'ReportElementForm',
  components: {
    ModelForm,
    ReportControls
  },
  props: {
    report: {
      type: Report,
      required: false,
      default: null
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    },
    handledActions: {
      type: Array,
      required: false,
      default () {
        return ['add', 'edit']
      }
    }
  },
  emits: ['model-created'],
  data () {
    return {
      tab: 'default',
      componentSearchValue: null,
      settingControls: []
    }
  },
  configuration: ['reportComponents', 'regionReportComponents'],
  models: {
    reportElement: {
      controls: 'default',
      possibleOptionsValues: 'default'
    }
  },
  computed: {
    filteredReportComponents () {
      return _.filter(
        this.report.regionReport ? this.regionReportComponents.data : this.reportComponents.data,
        component => component.name.toLowerCase().includes(this.componentSearchValue)
      )
    }
  },
  created () {
    _.extend(this, { optionNamesForControlName, isOptionSet, unsetOption })
  },
  methods: {
    show (model, initialValue) {
      this.$refs.modelForm.show(model, initialValue)
    },
    filterReportComponents (val, update, abort) {
      update(() => {
        this.componentSearchValue = val.toLowerCase()
      })
    },
    isOptionSetOrSetting (options, control) {
      return isOptionSet(options, control) || _.includes(this.settingControls, control)
    },
    toggleControl (options, control) {
      if (this.isOptionSetOrSetting(options, control)) {
        this.settingControls = _.without(this.settingControls, control)
        unsetOption(options, control)
      } else {
        this.settingControls = [...this.settingControls, control]
        setDefaultOption(options, this.reportElement.finalOptions, control)
      }
    }
  }
}

</script>
